import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { InstantSearch, Configure } from 'react-instantsearch';
import useIsBrowser from 'hooks/useIsBrowser';
import useStoreDetails from 'hooks/useStoreDetails';
import UpdateZipcodeSidebar from 'components/consumer/UpdateZipcodeSidebar';
import Error404 from 'components/consumer/404';
import { StoreCatalogProductResults } from 'components/consumer/consumer-search/commons/helpers';
import JBSearchBox from 'components/consumer/consumer-search/components/JBSearchBox';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import useUserLocation from 'global-state/userLocation/useUserLocation';
const searchStateDefault = {
  configure: {
    facetFilters: '',
    facets: []
  },
  hitsPerPage: 10,
  page: 1,
  query: ''
};
const AssociatePage = () => {
  const $ = _c(15);
  const isBrowser = useIsBrowser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...searchStateDefault
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [searchState, setSearchState] = useState(t0);
  const [isUpdateZipcodeOpen, updateZipcodeForm] = useState(false);
  const userLocation = useUserLocation();
  const storeDetails = useStoreDetails();
  const show404Page = isBrowser && !storeDetails;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setSearchState(_temp);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const incrementPageNum = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = updatedSearchState => {
      setSearchState(updatedSearchState);
      const resetIcon = document.querySelector(".ais-SearchBox-reset");
      if (!resetIcon || updatedSearchState?.query?.length > 0 && resetIcon.style.visibility === "visibility") {
        return;
      }
      if (updatedSearchState?.query?.length > 0) {
        resetIcon.style.visibility = "visible";
      } else {
        resetIcon.style.visibility = "hidden";
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onQueryChange = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      updateZipcodeForm(_temp2);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const toggleUpdateZipCodeSidebar = t3;
  let t4;
  if ($[4] !== show404Page) {
    t4 = show404Page && <Error404 />;
    $[4] = show404Page;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isUpdateZipcodeOpen || $[7] !== searchState || $[8] !== show404Page || $[9] !== storeDetails?.zipCode || $[10] !== userLocation?.zip) {
    t5 = !show404Page && <div className="mb-24 [&_.ais-SearchBox-reset]:invisible"><UpdateZipcodeSidebar isZipcodeFormOpen={isUpdateZipcodeOpen} onClose={toggleUpdateZipCodeSidebar} /><header className="flex justify-between items-center mt-[1.2rem] mx-4 mb-4"><div className="text-3xl font-bold">Catalog</div><div className="flex items-center"><span className="text-base mr-[15px]">{"Shipping time based on ZIP: "}<span className="text-brand">{`${userLocation?.zip || storeDetails?.zipCode || ""}`}</span></span><div><span className="text-base font-bold inline-block bg-brand text-white cursor-pointer align-middle px-5 py-[5px] text-center no-underline" role="button" onClick={toggleUpdateZipCodeSidebar} tabIndex={0}>{" "}Update ZIP{" "}</span></div></div></header><div className="associate-search-section"><InstantSearch searchClient={searchClient} searchState={searchState} indexName={ALGOLIA_INDEX_NAME.PRODUCTS} onSearchStateChange={onQueryChange}><Configure query={searchState.query} hitsPerPage={searchStateDefault.hitsPerPage} facets={["*"]} numericFilters="" /><JBSearchBox defaultRefinement={searchState.query} forPage="associate" placeholder="Search by product name, ID" /><div className="associate-product-results__container"><div className="associate-product-results__inner"><InstantSearch searchClient={searchClient} searchState={searchState} indexName={ALGOLIA_INDEX_NAME.PRODUCTS} onSearchStateChange={onQueryChange} key={searchState.query}><Configure query={searchState.query} hitsPerPage={searchStateDefault.hitsPerPage} facets={["*"]} numericFilters="" /><StoreCatalogProductResults onLoadMore={incrementPageNum} /></InstantSearch></div></div></InstantSearch></div></div>;
    $[6] = isUpdateZipcodeOpen;
    $[7] = searchState;
    $[8] = show404Page;
    $[9] = storeDetails?.zipCode;
    $[10] = userLocation?.zip;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default AssociatePage;
function _temp(prevState) {
  return {
    ...prevState,
    page: prevState.page + 1
  };
}
function _temp2(prev) {
  return !prev;
}